/*
 * Katana Spec — radar/spider chart with per-model logo switching.
 * Logos are fetched + inlined so they recolour; the chart shows a smooth
 * "splat" blob (inner dip points, no vertex dots) with a radial gradient fill
 * that fades outward into the border; the centre shows a selectable image; the
 * whole info section (text / colours / button) crossfades between models.
 */
(function () {
  'use strict';

  var SVGNS = 'http://www.w3.org/2000/svg';
  var CX = 200, CY = 200, R = 150, INNER = 52;

  // Smooth closed path (Catmull-Rom -> cubic bezier) for a blob shape.
  function smoothPath(pts) {
    var n = pts.length, d = '';
    for (var i = 0; i < n; i++) {
      var p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      if (i === 0) d += 'M' + p1[0].toFixed(2) + ',' + p1[1].toFixed(2);
      var c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
      var c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
      d += 'C' + c1x.toFixed(2) + ',' + c1y.toFixed(2) + ' ' +
        c2x.toFixed(2) + ',' + c2y.toFixed(2) + ' ' +
        p2[0].toFixed(2) + ',' + p2[1].toFixed(2);
    }
    return d + 'Z';
  }

  function injectLogo(container, url) {
    if (!url) { container.innerHTML = ''; return; }
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        if (txt.indexOf('<svg') !== -1) container.innerHTML = txt.slice(txt.indexOf('<svg'));
        else container.innerHTML = '<img src="' + url + '" alt="">';
      })
      .catch(function () { container.innerHTML = '<img src="' + url + '" alt="">'; });
  }

  function initSection(section) {
    var dataEl = section.querySelector('[data-kspec-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var axes = data.axes || [];
    var models = data.models || [];
    if (!models.length) return;

    var svg = section.querySelector('[data-kspec-radar]');
    var modelsEl = section.querySelector('[data-kspec-models]');
    var centre = section.querySelector('[data-kspec-centre]');
    var iDesc = section.querySelector('[data-i-desc]');
    var iSwatches = section.querySelector('[data-i-swatches]');
    var iPrice = section.querySelector('[data-i-price]');
    var iBuild = section.querySelector('[data-i-build]');
    var info = section.querySelector('.kspec__info');

    function pt(i, v) {
      var a = (-90 + i * (360 / axes.length)) * Math.PI / 180;
      var r = INNER + (v / 100) * (R - INNER);
      return [CX + r * Math.cos(a), CY + r * Math.sin(a)];
    }
    function mk(t, attrs) {
      var e = document.createElementNS(SVGNS, t);
      for (var k in attrs) e.setAttribute(k, attrs[k]);
      return e;
    }

    [0, 0.5, 1].forEach(function (f) {
      svg.appendChild(mk('polygon', {
        points: axes.map(function (_, i) { return pt(i, f * 100).join(','); }).join(' '),
        class: 'kspec__ring'
      }));
    });
    var labelEls = [];
    axes.forEach(function (label, i) {
      var p0 = pt(i, 0), p1 = pt(i, 100);
      svg.appendChild(mk('line', { x1: p0[0], y1: p0[1], x2: p1[0], y2: p1[1], class: 'kspec__axis' }));
      var pl = pt(i, 120);
      var t = mk('text', { x: pl[0], y: pl[1], class: 'kspec__axis-label', 'text-anchor': 'middle', 'dominant-baseline': 'middle' });
      t.textContent = label;
      labelEls.push(t);
    });

    // Splat shape: add an inner point between each axis, pulled toward the
    // centre by (neighbours' average - 20), so the gaps dip inward.
    function ptAt(angleDeg, val) {
      var a = (-90 + angleDeg) * Math.PI / 180;
      var r = INNER + (val / 100) * (R - INNER);
      return [CX + r * Math.cos(a), CY + r * Math.sin(a)];
    }
    function buildPoints(v) {
      var n = v.length, stepA = 360 / n, pts = [];
      for (var i = 0; i < n; i++) {
        pts.push(ptAt(i * stepA, v[i]));
        var nx = (i + 1) % n;
        var mid = Math.max(0, (v[i] + v[nx]) / 2 - 30);
        pts.push(ptAt(i * stepA + stepA / 2, mid));
      }
      return pts;
    }

    // Radial fill gradient in a constant chart colour: faint centre -> opaque
    // outer, so the fill blends into the border line.
    var chartColor = data.chartColor || '#d2ae4e';
    var gid = 'kspecFill_' + Math.random().toString(36).slice(2, 9);
    var defs = mk('defs', {});
    // objectBoundingBox units (default) so the gradient scales with the blob's
    // bounding box -> it adjusts as the shape's edges reach further out/in.
    var grad = mk('radialGradient', { id: gid, cx: '50%', cy: '50%', r: '55%' });
    var stopIn = mk('stop', { offset: '0%' });
    stopIn.setAttribute('stop-color', chartColor);
    stopIn.setAttribute('stop-opacity', '0.1');
    var stopMid = mk('stop', { offset: '50%' });
    stopMid.setAttribute('stop-color', chartColor);
    stopMid.setAttribute('stop-opacity', '0.4');
    var stopOut = mk('stop', { offset: '100%' });
    stopOut.setAttribute('stop-color', chartColor);
    stopOut.setAttribute('stop-opacity', '1');
    grad.appendChild(stopIn);
    grad.appendChild(stopMid);
    grad.appendChild(stopOut);
    defs.appendChild(grad);
    svg.appendChild(defs);

    var fillPath = mk('path', { class: 'kspec__fill' });
    fillPath.setAttribute('fill', 'url(#' + gid + ')');
    var strokePath = mk('path', { class: 'kspec__poly' });
    svg.appendChild(fillPath);
    svg.appendChild(strokePath);

    // Axis labels sit in front of the fill.
    labelEls.forEach(function (t) { svg.appendChild(t); });

    var current = models[0].specs.slice();
    function draw(v) {
      var d = smoothPath(buildPoints(v));
      fillPath.setAttribute('d', d);
      strokePath.setAttribute('d', d);
    }
    var raf;
    function morph(target) {
      cancelAnimationFrame(raf);
      var start = current.slice(), t0 = performance.now(), dur = 650;
      (function step(now) {
        var p = Math.min((now - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        current = start.map(function (v, i) { return v + (target[i] - v) * e; });
        draw(current);
        if (p < 1) raf = requestAnimationFrame(step);
      })(performance.now());
    }

    function renderSwatches(colors) {
      iSwatches.innerHTML = '';
      (colors || []).forEach(function (c) {
        var d = document.createElement('div');
        d.className = 'kspec__swatch';
        if (c.kind === 'image') d.style.backgroundImage = 'url("' + c.value + '")';
        else d.style.background = c.value;
        iSwatches.appendChild(d);
      });
    }

    var slideTimer = null;

    function setCentre(m) {
      centre.classList.add('is-swapping');
      centre.style.setProperty('--centre-scale', (m.centreScale || 100) / 100);
      centre.style.setProperty('--logo-scale', (m.logoScale || 100) / 100);
      centre.style.color = '#ffffff';
      if (slideTimer) { clearInterval(slideTimer); slideTimer = null; }
      setTimeout(function () {
        var urls = m.centreUrls || [];
        if (urls.length) {
          var html = '<div class="kspec__centre-media">';
          for (var i = 0; i < urls.length; i++) {
            html += '<img class="kspec__centre-slide' + (i === 0 ? ' is-shown' : '') +
              '" src="' + urls[i] + '" alt="">';
          }
          centre.innerHTML = html + '</div>';
          if (urls.length > 1) {
            var slides = centre.querySelectorAll('.kspec__centre-slide');
            var idx = 0;
            slideTimer = setInterval(function () {
              slides[idx].classList.remove('is-shown');
              idx = (idx + 1) % slides.length;
              slides[idx].classList.add('is-shown');
            }, 3200);
          }
        } else if (m.logoUrl) {
          centre.innerHTML = '<span class="kspec__centre-logo"></span>';
          injectLogo(centre.querySelector('.kspec__centre-logo'), m.logoUrl);
        } else {
          centre.innerHTML = '';
        }
        centre.classList.remove('is-swapping');
      }, 420);
    }

    function applyContent(m) {
      iDesc.textContent = m.desc || '';
      iPrice.textContent = m.price || '';
      renderSwatches(m.colors);
    }

    // Bring the model options just below the fixed header (clear of the gradient).
    function scrollModelsBelowHeader() {
      var chrome = document.querySelector('.khero__chrome');
      var chromeH = chrome ? chrome.getBoundingClientRect().height : 110;
      var gap = 48;
      // On mobile the models land too close to the header; drop them ~5vh lower.
      if (window.innerWidth <= 760) {
        gap += window.innerHeight * 0.05;
      }
      var top = window.pageYOffset + modelsEl.getBoundingClientRect().top - chromeH - gap;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    var cells = [];
    function select(i, doReveal) {
      var m = models[i];
      cells.forEach(function (c, j) { c.classList.toggle('is-active', j === i); });
      morph(m.specs);
      setCentre(m);
      if (iBuild) iBuild.setAttribute('href', m.build || '#');
      // Fade the whole text/colour/button section out and back in.
      if (doReveal && info) {
        info.style.opacity = '0';
        setTimeout(function () {
          applyContent(m);
          info.style.opacity = '1';
        }, 220);
      } else {
        applyContent(m);
      }
    }

    // Clear the server-rendered model names before building the logo tabs.
    modelsEl.innerHTML = '';

    models.forEach(function (m, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kspec__model' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      if (m.name) btn.setAttribute('aria-label', m.name);
      btn.style.setProperty('--logo-scale', (m.logoScale || 100) / 100);
      btn.style.setProperty('--kspec-hl', m.highlight || '#ffffff');
      var logoSpan = document.createElement('span');
      logoSpan.className = 'kspec__model-logo';
      btn.appendChild(logoSpan);
      injectLogo(logoSpan, m.logoUrl);
      if (m.name) {
        var nameEl = document.createElement('span');
        nameEl.className = 'kspec__model-name';
        nameEl.textContent = m.name;
        btn.appendChild(nameEl);
      }
      btn.addEventListener('click', function () {
        select(i, true);
        scrollModelsBelowHeader();
      });
      modelsEl.appendChild(btn);
      cells.push(btn);
    });

    draw(current);
    select(0, false);

    var revealed = false;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !revealed) {
            revealed = true;
            select(0, true);
            io.disconnect();
          }
        });
      }, { threshold: 0.3 });
      io.observe(section);
    }
  }

  function boot() {
    var sections = document.querySelectorAll('[data-kspec]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
